import React, { useState } from "react";
import { Row, Table } from "react-bootstrap";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { CircularProgress } from "../../components/custom";
import { PATH_DASHBOARD } from "../../routes/paths";
import { useDispatch } from "react-redux/es/hooks/useDispatch";
import { fetchCurrentTerm } from "../../redux/slices/term";
import { AllTerms } from "../../configs/AllTerms";
import { AllSessions } from "../../constants/AllSessions";
import { AllClasses } from "../../configs/allClasses";
import { useSelector } from "react-redux";
import { api } from "../../api/axios";

const FILTER_KEY = "admin_results_filters";

export default function Reports() {
  const [loading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  // Restore from sessionStorage on mount so filters survive navigate(-1)
  const savedFilters = JSON.parse(sessionStorage.getItem(FILTER_KEY) || "{}");
  const [students, setStudents] = useState(savedFilters.students || []);
  const [results, setResults] = useState(savedFilters.results || []);
  const [termName, setTermName] = useState(savedFilters.termName || "");
  const [session, setSession] = useState(savedFilters.session || "");
  const [selectedClass, setClass] = useState(savedFilters.selectedClass || "");
  const [searched, setSearched] = useState(savedFilters.searched || false);
  const { isLoading } = useSelector((state) => state.users);

  // Save filters to sessionStorage whenever they change
  useEffect(() => {
    sessionStorage.setItem(
      FILTER_KEY,
      JSON.stringify({
        termName,
        session,
        selectedClass,
        results,
        students,
        searched,
      }),
    );
  }, [termName, session, selectedClass, results, students, searched]);

  //current term (just to pre-fill the term label in the page description)
  useEffect(() => {
    dispatch(fetchCurrentTerm())
      .unwrap()
      .catch((error) => {});
  }, []);

  const getResults = async () => {
    if (!session || !termName || !selectedClass) {
      return alert(
        "Please select a Term, Session, and Class before checking results.",
      );
    }
    try {
      setIsLoading(true);
      const response = await api.get(
        `/results/studentsresults/${session}/${termName}/${selectedClass}`,
      );
      if (response.data.results.length > 0) {
        setResults(response?.data?.results[0]?.results);
        // Use enriched students returned by the backend — works for historical classes after promotion
        setStudents(response?.data?.students || []);
      } else {
        setResults([]);
        setStudents([]);
      }
    } catch (error) {
      console.error("Error fetching results:", error);
    } finally {
      setIsLoading(false);
      setSearched(true);
    }
  };
  return (
    <>
      <Page className="py-5">
        <div className="d-flex flex-row justify-content-between container align-items-center">
          <div>
            <h4>Uploaded Results</h4>
            <p>
              Select term and session to see list of available results for{" "}
              {termName}, of any class chosen.
            </p>
          </div>
        </div>
        <div className="select-wrapper d-flex flex-row flex-wrap p-3 px-4 mt-5 justify-content-start gap-3 align-items-end">
          <div className="d-flex flex-column gap-1">
            <div>
              <h6>Term</h6>
            </div>
            <select
              value={termName}
              onChange={(e) => {
                setTermName(e.target.value);
              }}
            >
              <option value="" disabled>
                Select Term
              </option>
              {AllTerms?.map((opt, index) => (
                <option key={index} value={opt.code}>
                  {opt.name}
                </option>
              ))}
            </select>
          </div>{" "}
          <div className="d-flex flex-column gap-1">
            <div>
              <h6>Session</h6>
            </div>
            <select
              value={session}
              onChange={(e) => {
                setSession(e.target.value);
              }}
            >
              <option value="" disabled>
                Select Session
              </option>
              {AllSessions?.map((opt, index) => (
                <option key={index} value={opt.code}>
                  {opt.name}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex flex-column gap-1">
            <div>
              <h6>Class</h6>
            </div>
            <select
              value={selectedClass}
              onChange={(e) => {
                setClass(e.target.value);
              }}
              className="select-class"
            >
              <option value="" disabled>
                Select Class
              </option>
              {AllClasses?.map((opt, index) => (
                <option key={index} value={opt.code}>
                  {opt.name}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={() => {
              getResults();
            }}
            className="check-btn"
          >
            check
          </button>
        </div>
        {students?.length > 0 && results?.length > 0 ? (
          <Wrapper className="d-flex flex-column py-5">
            {results?.length > 0 ? (
              <div className="table-wrapper container py-5">
                <div className="d-flex flex-row justify-content-start align-items-start text-start">
                  <h6 className="m-0">
                    List of Uploaded Resullts for {termName}, {session}.
                  </h6>
                </div>
                <div className="table-div p-0 mt-3">
                  <table className="table  p-0">
                    <thead>
                      <tr>
                        <th>Admission No.</th>
                        <th>First Name</th>
                        <th>Middle Name</th>
                        <th>Surname</th>
                        <th>Gender</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {results.map((result, index) => {
                        const student = students?.find(
                          (student) => student?.admissionNumber === result[0],
                        );
                        return (
                          <tr key={index}>
                            <td>{result[0]}</td>
                            <td>{student ? student?.firstName : ""}</td>
                            <td>{student ? student?.middleName : ""}</td>
                            <td>{student ? student?.lastName : ""}</td>
                            <td>{student ? student?.gender : ""}</td>
                            <td>
                              <button className="view-button">
                                <Link
                                  className="react-router-link"
                                  to={{
                                    pathname: `${PATH_DASHBOARD.admin.view}/${student?._id}/${termName}/${session}/${selectedClass}`,
                                    state: {
                                      termName: termName,
                                      activeSession: session,
                                    },
                                  }}
                                >
                                  View
                                </Link>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="text-center d-flex flex-column mt-4">
                <p className="m-0">
                  List of Uploaded Results Will Display Here
                </p>
              </div>
            )}
          </Wrapper>
        ) : (
          <div className="text-center d-flex flex-column mt-4">
            <h4 className="m-0">No Results Found</h4>
            <p>
              Make sure the results you are looking for have been uploaded by
              the class teacher.
            </p>
          </div>
        )}
      </Page>
      {isLoading || loading ? <CircularProgress /> : ""}
    </>
  );
}
const Wrapper = styled.div`
  background-color: #f5f5f5 !important;
  .table {
    width: 100%;
    border: 1px solid grey;
    border-collapse: collapse;
  }
  .select-class {
    height: 100% !important;
  }
  .table-div {
    width: 100%;
    overflow-x: auto !important;
  }
  td,
  th {
    border: 1px solid grey;
  }
  thead {
    border-bottom: 1px solid grey !important;
  }
  th {
    font-size: 500 !important;
  }
  td {
    font-weight: 300 !important;
  }
  .table-wrapper {
    background-color: white !important;
  }
`;
const Page = styled.div`
  .select-wrapper {
    width: 100%;
    align-items: center;
    width: fit-content;
    span {
      align-items: flex-end;
      justify-content: right;
      color: grey;
    }
    select {
      width: 200px !important;
      padding: 10px;
      border: 1px solid grey;
      color: grey;
      border-radius: 10px;
      background: transparent;
    }
    h6 {
      font-weight: 500 !important;
      font-size: 17px;
      margin: 0 !important;
    }
  }

  .check-btn {
    padding: 5px 20px;
    border: 1px solid blue;
    color: white;
    background-color: blue;
    border-radius: 10px;
  }
  .d-flex {
    flex-wrap: wrap;
  }
  h4,
  p {
    margin: 0;
  }
  p {
    font-weight: 300;
  }
  .upload-btn {
    font-size: 15px;
    border: 1px solid green;
    background-color: green;
    padding: 5px 15px;
    height: fit-content;
    color: white;
  }
`;
